import { render } from "./ServicioExternoList.vue?vue&type=template&id=706c6c9e&scoped=true"
import script from "./ServicioExternoList.vue?vue&type=script&lang=js"
export * from "./ServicioExternoList.vue?vue&type=script&lang=js"

import "./ServicioExternoList.vue?vue&type=style&index=0&id=706c6c9e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706c6c9e"]])

export default __exports__